<script setup lang="ts">
const { sliderEnabled } = useCustom();
useSeoMeta({
  title: "404 - Tutassûr",
});
</script>
<template>
  <div
    :class="[
      { 'cursor-enabled': sliderEnabled },
      { 'cursor-disabled': !sliderEnabled },
    ]"
  >
    <LayoutHeader />
    <LayoutCustomCursor v-if="sliderEnabled" />

    <Error404MainSection />
  </div>
</template>
<style>
.cursor-enabled {
  cursor: url("./assets/img/custom/defaultCursor.svg"), auto;
}
.cursor-disabled .cursor-hover {
  cursor: pointer !important;
}
</style>
